import { AreaAccessStatus } from 'ufinet-web-functions'

export const getBadgeVariant = (accessAreaStatus: AreaAccessStatus) => {
	return accessAreaStatus === AreaAccessStatus.CONNECTED
		? 'connected'
		: accessAreaStatus === AreaAccessStatus.NEAR_NETWORK
		? 'near'
		: 'not-connected'
}
